//function to open Carousel
export const openCarousel = (images) => {
    const carouselHtml = `
        <html>
        <head>
        <title>Image Viewer</title>
        <style>
            body { 
            margin:0; 
            display:flex; 
            align-items:center; 
            justify-content:center; 
            background:#000; 
            color:white; 
            height:100vh; 
            }
            .container { 
            position:relative; 
            width:80%; 
            height:80%; 
            display:flex;
            align-items:center;
            justify-content:center;
            background:black;
            }
            .image-wrapper {
            width:100%;
            height:100%;
            display:flex;
            align-items:center;
            justify-content:center;
            background:black;
            }
            .image-wrapper img {
            width:100%;      /* force same width */
            height:100%;     /* force same height */
            object-fit:contain; /* keep full image visible */
            background:black;
            }
            .arrow { 
            position:absolute; 
            top:50%; 
            transform:translateY(-50%); 
            font-size:40px; 
            cursor:pointer; 
            user-select:none; 
            color:white; 
            opacity:0.7; 
            }
            .arrow.disabled { opacity:0.3; cursor:not-allowed; }
            .left { left:10px; }
            .right { right:10px; }
            .counter {
            position:absolute;
            bottom:10px;
            left:50%;
            transform:translateX(-50%);
            background:rgba(0,0,0,0.5);
            padding:4px 12px;
            border-radius:12px;
            font-size:14px;
            color:white;
            }
        </style>
        </head>
        <body>
        <div class="container">
            <span class="arrow left" onclick="prev()" id="leftArrow">&#10094;</span>
            <div class="image-wrapper">
            <img id="viewer" src="${images[0]}" />
            </div>
            <span class="arrow right" onclick="next()" id="rightArrow">&#10095;</span>
            <div class="counter" id="counter">1 / ${images.length}</div>
        </div>
        <script>
            var imgs = ${JSON.stringify(images)};
            var index = 0;

            function update() {
            document.getElementById("viewer").src = imgs[index];
            document.getElementById("counter").innerText = (index+1) + " / " + imgs.length;

            // disable left arrow at first image
            document.getElementById("leftArrow").classList.toggle("disabled", index === 0);
            // disable right arrow at last image
            document.getElementById("rightArrow").classList.toggle("disabled", index === imgs.length - 1);
            }

            function prev() {
            if (index > 0) {
                index--;
                update();
            }
            }

            function next() {
            if (index < imgs.length - 1) {
                index++;
                update();
            }
            }

            // hide arrows completely if only 1 image
            if (imgs.length <= 1) {
            document.getElementById("leftArrow").style.display = "none";
            document.getElementById("rightArrow").style.display = "none";
            } else {
            update();
            }
        </script>
        </body>
        </html>
    `;

    const win = window.open("", "_blank");
    win.document.write(carouselHtml);
    win.document.close();
  };